import { z } from 'zod';


export const genderEnumSchema = z.enum(['male', 'female']);
export type GenderEnum = z.infer<typeof genderEnumSchema>;
export type Gender = GenderEnum;
export const activityLevelSchema = z.enum(['sedentary', 'lightly-active', 'moderately-active', 'very-active', 'extra-active']);
export type ActivityLevel = z.infer<typeof activityLevelSchema>;


export const bmrFormula = z.enum(['obese', 'revised']);
export type bmrFormula = z.infer<typeof bmrFormula>;
export type BmrFormula = bmrFormula;

export const foodAttributionSourceEnumSchema = z.enum(['fdc:foundation', 'fdc:branded', 'fdc:sr_legacy', 'user:photos']);
export type FoodAttributionSourceType = z.infer<typeof foodAttributionSourceEnumSchema>;
export type FoodAttributionSourceEnum = FoodAttributionSourceType;
